import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Icon, IconButton } from '@kontentino/ui';
import EntityDetailLayout from 'app/components/EntityDetailLayout';
import { PostModalOnClose } from 'app/modules/posts/modules/post/hooks/usePostModal';
import { faClose } from '@fortawesome/pro-regular-svg-icons/faClose';
type Props = {
  onClose: PostModalOnClose;
  reason?: string;
};

const PostDetailError: FC<Props> = (props) => {
  const { t } = useTranslation();
  return (
    <EntityDetailLayout
      header={
        <>
          <div className="tw-flex tw-py-4 tw-pl-6 tw-pr-5">
            <IconButton
              variant="secondary"
              onClick={() => props.onClose()}
              size="small"
              icon={<Icon icon={faClose} />}
              className="tw-ml-auto"
            />
          </div>
          <div className="tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-p-6">
            <Alert
              variant="danger"
              title={t('somethingWentWrong')}
              cta={{
                label: t('close'),
                onClick: () => props.onClose(),
              }}
            >
              {props.reason ?? t('pleaseCloseModalAndTryAgain')}
            </Alert>
          </div>
        </>
      }
    />
  );
};

export default PostDetailError;
